module.exports = __webpack_public_path__ + "img/getfin-icon-mini.25d2dcc1.png";